<template>
  <div class="container-fluid">
    <TheHeader :stationName="viewName" />
    <div class="ps-4 pe-4 pt-3">
      <FluxForm :station-id="stationId" :table-url="tableUrl"></FluxForm>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import TheHeader from "@/components/layouts/TheHeader.vue";
import FluxForm from "@/components/flux/FluxForm.vue";

const stationId = 59;
const viewName = "Flux";
const tableUrl = `/Material/GetLastFlux?num=10`;

onMounted(() => {
  document.title = viewName;
});
</script>
